import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMetaMuseImageAiGeneratorConfig } from '@/data/landingConfig/landingMetaMuseImageAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MetaMuseImageAiGenerator } from './schemaObject';

interface Props {}
const MetaMuseImageAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MetaMuseImageAiGenerator} />
			<LandingTemplate
				data={landingMetaMuseImageAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default MetaMuseImageAiGenerator;
